export default "https://assets.egbcdn.net/assets/packs/_/images/gifts-icon-7730b8712cd0e8b80bf5efa982aeac03.png";